import { atom } from 'jotai';
import { CallWithTimestamp } from '../typings';

export const callQueueBannerVisibleAtom = atom<boolean>(false);

export const callsAtom = atom<Array<CallWithTimestamp>>([]);